// @flow

class Country {
  code: string;
  label: string;
  phone: string;

  constructor(code: string, label: string, phone: string) {
    this.code = code;
    this.label = label;
    this.phone = phone;
  }

  static find(countries: Country[], value: ?string): ?Country {
    if (countries.length > 0 && value) {
      return countries.find((country) => country.code === value || country.label === value);
    }
    return null;
  }

  flag(): string {
    return typeof String.fromCodePoint !== 'undefined'
      ? this.code
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
      : this.code;
  }
}

export default Country;
